import { useTranslation } from "react-i18next";
import { ErrorTranslateKey } from "../i18n/i18n.types";

/**
 * A hook for looking up messages for error codes returned from the back-end API.
 *
 * @returns Function for retrieving an error message by key from the errors translation file.
 */
export const useErrorCodes = () => {
  const { t } = useTranslation("errors");

  // If the given key is not found, we fallback to the key itself.
  const lookup = (key: string): string =>
    (t(key as ErrorTranslateKey) as string | undefined) ?? key;

  return { lookup };
};
